<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          Styles
          <CButton size="sm" style="float:right;" color="success" @click="addModal = true">Add Style</CButton>
        </CCardHeader>
        <CCardBody>
          <CAlert
            :show.sync="dismissCountDown"
            color="primary"
            fade
          >
            ({{dismissCountDown}}) {{ message }}
          </CAlert>
          <CDataTable
            :items="items"
            :fields="fields"
            column-filter
            table-filter
            :items-per-page="10"
            pagination
          >
          <!-- <template #show="{item}">
            <td>
              <CButton size="sm" color="primary" @click="show( item.program_id )">Show</CButton>
            </td>
          </template> -->
          <template #style_description="{item}">
            <td>
              <input type="text" v-model="item.style_description" @change="descriptionChanged(item)" class="form-control" />
            </td>
          </template>
          <template #active="{item}">
            <td>
              <CButton size="sm" @click="save(item, 1, 'active')" :color="item.active === 1 ? 'success': 'outline-success'">Active</CButton>
              <CButton size="sm" @click="save(item, 0, 'active')" style="margin-left:5px;" :color="item.active === 0 ? 'danger': 'outline-danger'">Inactive</CButton>
            </td>
          </template>
          <template #dropping_style="{item}">
            <td>
              <CButton size="sm" @click="save(item, 1, 'dropping_style')" :color="item.dropping_style === 1 ? 'success': 'outline-success'">Drop Style</CButton>
              <CButton size="sm" @click="save(item, 0, 'dropping_style')" style="margin-left:5px;" :color="item.dropping_style === 0 ? 'danger': 'outline-danger'">Keep Style</CButton>
            </td>
          </template>
          <template #edit="{item}">
            <td>
              <CButton size="sm" color="primary" @click="edit( item.style_id )">Edit</CButton>
            </td>
          </template>
          <!-- <template #delete="{item}">
            <td>
              <CButton size="sm" v-if="you!=item.id" color="danger" @click="deleteUser( item.id )">Delete</CButton>
            </td>
          </template> -->
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>

      <CModal
        title="Add Style"
        :show.sync="addModal"
      >
        <CForm>
          <CInput
            :lazy="false"
            :value.sync="form.style_name"
            placeholder="Style Name"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
        </CForm>
        <template #footer>
          <CButton @click="addModal = false, reset()" color="danger">Cancel</CButton>
          <CButton @click="add()" color="success">Add</CButton>
        </template>
      </CModal>

      <CModal
        title="Edit Program"
        :show.sync="editModal"
      >
        <CForm v-if="editForm">
          <CInput
            :lazy="false"
            :value.sync="editForm.style_name"
            placeholder="Program Name"
            autocomplete="given-name"
            invalidFeedback="This is a required field"
          />
        </CForm>
        <template #footer>
          <CButton @click="editModal = false, resetEdit()" color="danger">Cancel</CButton>
          <CButton @click="save()" color="success">Save</CButton>
        </template>
      </CModal>
    </CCol>
  </CRow>
</template>

<script>
var methods = {}

methods.descriptionChanged = function (item) {
  console.log('changed')
  axios.post(this.$apiAdress + '/api/styles/update?token=' + localStorage.getItem('api_token'), item)
  .then(function (response) {

  }).catch(function (error) {
    console.log(error)
  })
}

methods.getData = function () {
  let self = this
  axios.get( this.$apiAdress + '/api/styles?token=' + localStorage.getItem("api_token"))
  .then(function (response) {
    console.log(response)
    self.items = response.data
  }).catch(function (error) {
    console.log(error)
  });
}

methods.reset = function () {
  this.form = {name: ''}
}

methods.resetEdit = function () {
  this.editModal = null
}

methods.edit = function (val) {
  this.$router.push({ path: '/styles/' + val + '/edit' })
}

methods.save = function (item, val, type) {
  item[type] = val
  let self = this
  console.log(item)
  axios.post(this.$apiAdress + '/api/styles/update?token=' + localStorage.getItem('api_token'), item)
  .then(function (response) {

  }).catch(function (error) {
    console.log(error)
  })
}

methods.add = function () {
  let self = this;
  axios.post(   this.$apiAdress + '/api/styles/store?token=' + localStorage.getItem("api_token"),
    self.form
  )
  .then(function (response) {
      console.log(response)
      self.$router.push({ path: '/styles/' + response.data.style_id + '/edit' })
      // self.items.push(response.data)
      // self.form = {style_name: ''}
      // self.addModal = false
  }).catch(function (error) {
      // if(error.response.data.message == 'The given data was invalid.'){
      //   self.message = '';
      //   for (let key in error.response.data.errors) {
      //     if (error.response.data.errors.hasOwnProperty(key)) {
      //       self.message += error.response.data.errors[key][0] + '  ';
      //     }
      //   }
      //   self.showAlert();
      // }
  });
}

methods.getForm = function () {
  return {
    style_name: ''
  }
}

export default {
  name: 'Styles',
  data() {
    return {
      items: [],
      fields: ['style_name', 'style_description', 'active', 'edit'],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      addModal: false,
      form: this.getForm(),
      editForm: null,
      editModal: false
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  methods: methods,
  mounted: function(){
    this.getData()
  }
}
</script>
